import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { LocalStorageService } from "@malirang/front-share";
import { catchError, from, mergeMap, throwError } from "rxjs";

export const LP_AUTH_KEY = "malirang_lp_auth_key";

export const HttpInterceptor: HttpInterceptorFn = (req, next) => {
    const localStorageService = inject(LocalStorageService);

    return from(
        (async () => {
            const accessToken = await localStorageService.get(LP_AUTH_KEY);

            return req.clone({
                setHeaders: {
                    Authorization: accessToken ? `Bearer ${accessToken}` : "",
                },
            });
        })(),
    ).pipe(
        mergeMap((updatedRequest) => next(updatedRequest)),
        catchError((e) => {
            return throwError(() => e.error);
        }),
    );
};
